(function () {
  var root = document.querySelector('[data-reviva-nl]');
  if (!root) return;

  var SEEN_KEY = 'reviva_nl_seen';
  var SUB_KEY = 'reviva_nl_sub';
  var DELAY_MS = 2500;
  var REPEAT_DAYS = 7;

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function subscribed() { return get(SUB_KEY) === '1'; }
  function seenRecently() {
    var t = parseInt(get(SEEN_KEY) || '0', 10);
    return t ? (Date.now() - t) < REPEAT_DAYS * 24 * 60 * 60 * 1000 : false;
  }

  var lastFocus = null;

  function open(focusInput) {
    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    void root.offsetWidth;
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    if (focusInput) {
      var input = root.querySelector('.reviva-nl__input');
      if (input) setTimeout(function () { input.focus(); }, 300);
    }
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    set(SEEN_KEY, String(Date.now()));
    root.setAttribute('aria-hidden', 'true');
    setTimeout(function () { root.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showSuccess() {
    set(SUB_KEY, '1');
    set(SEEN_KEY, String(Date.now()));
    var f = root.querySelector('[data-nl-form]');
    var s = root.querySelector('[data-nl-success]');
    if (f) f.hidden = true;
    if (s) s.hidden = false;
  }

  // chiusura: backdrop, X, ESC
  root.querySelectorAll('[data-nl-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // copia codice
  var codeBtn = root.querySelector('[data-nl-copy]');
  var copied = root.querySelector('[data-nl-copied]');
  if (codeBtn) {
    codeBtn.addEventListener('click', function () {
      if (navigator.clipboard) navigator.clipboard.writeText(codeBtn.textContent.trim()).catch(function () {});
      if (copied) copied.hidden = false;
    });
  }

  // Il modulo nativo di Shopify ricarica la pagina dopo l'invio.
  // window.__revivaNl viene impostato dal Liquid: 'success' o 'error'.
  var posted = window.__revivaNl;
  if (posted === 'success') {
    showSuccess();
    open(false);
  } else if (posted === 'error') {
    open(true); // riapre il modulo con l'errore visibile, per riprovare
  } else if (!subscribed() && !seenRecently()) {
    setTimeout(function () { open(true); }, DELAY_MS);
  }
})();
